"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var wifi_home_svg_1 = __importDefault(require("../../../assets/icons/construcao/wifi_home.svg"));
var foundation_svg_1 = __importDefault(require("../../../assets/icons/construcao/foundation.svg"));
var garden_cart_svg_1 = __importDefault(require("../../../assets/icons/construcao/garden_cart.svg"));
var holiday_village_svg_1 = __importDefault(require("../../../assets/icons/construcao/holiday_village.svg"));
var home_work_svg_1 = __importDefault(require("../../../assets/icons/construcao/home_work.svg"));
var in_home_mode_svg_1 = __importDefault(require("../../../assets/icons/construcao/in_home_mode.svg"));
var Construcao = {
    "wifi_home": wifi_home_svg_1.default,
    "foundation": foundation_svg_1.default,
    "garden_cart": garden_cart_svg_1.default,
    "holiday_village": holiday_village_svg_1.default,
    "home_work": home_work_svg_1.default,
    "in_home_mode": in_home_mode_svg_1.default,
};
exports.default = Construcao;
